import _ from "lodash";
import numeral from "numeral";
import { useMemo } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useRetireStore } from "../../../_store/retireStore";
import { useStrategyStore } from "../../../_store/strategyRetireStore";
import { useTaxStore } from "../../../_store/taxplanStore";
import LineChartMain from "../../../components/chart/LineChartMain";
import { InvestmentReturnCal } from "../../../functions/retirement/retirementFunction";
import { InvestmentReturnCalAfter } from "../../../functions/retirement/retirementFunctionAfter";
import { cn } from "../../../utils/useFunctions";
import {
  ICON_CHECK,
  ICON_CLOSE,
  ICON_STAR,
  ICON_WARNING,
} from "../../../utils/useIcons";
import { calPMTFVA } from "../../education/functions/function";
import {
  dataAge,
  dataAgeAF,
} from "../../retirement_plan/functions/functionRetriementPlan";
import { calculateTax, checkSum } from "../../tax_plan/functions";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_NORMAL_11,
} from "../styles/pdf.style";
import { useEducationStore } from "../../../_store/educationStore";

function PdfPageRetireTwo({ page }) {
  const balanceData = useBalanceStore((state) => state.balanceData);
  const retireData = useRetireStore((state) => state.retireData);
  const taxData = useTaxStore((state) => state.taxData);
  const strategy = useStrategyStore((state) => state.strategy);
  const educationData = useEducationStore((state) => state.educationData);

  const straigyLists = strategy?.map((item) => item?.key);

  const convertYearToMonth = (year) => {
    return year * 12;
  };

  const getInvestSumAF = useMemo(() => {
    return InvestmentReturnCalAfter(
      retireData,
      strategy,
      balanceData,
      educationData
    )?.map((af_investment_assets, index) => {
      return {
        result: af_investment_assets?.asset_invest,
        age: retireData?.af_plan_age[index],
      };
    });
  }, [strategy]);

  const getCaltax = () => {
    let result = 0;
    result =
      taxData?.tax_income -
      taxData?.deduction_expenses -
      taxData?.deduct_summary;
    return calculateTax(result);
  };

  const strategyLists = strategy?.map((item) => item?.key);

  const afterDiffYearCheck = strategyLists?.includes("strategy_age_retire")
    ? retireData?.strategy_age_retire - retireData?.age_current
    : retireData?.age_retire - retireData?.age_current;

  const dataPlanBf = [
    ...InvestmentReturnCal(
      retireData,
      balanceData,
      strategy,
      educationData
    )?.map((bf_investment_assets) => {
      return bf_investment_assets?.asset_invest;
    }),
  ];

  // หนี้สินต่อสินทรัพย์
  const valueDebttoTotalAsset = useMemo(() => {
    let sum = 0;
    if (balanceData?.debt_propotion) {
      sum =
        balanceData?.property_propotion > 0
          ? (balanceData?.debt_propotion / balanceData?.property_propotion) *
            100
          : 0;
    }
    return sum;
  }, [balanceData]);
  const getDebttoTotalAssetStatus = () => {
    if (!balanceData?.debt_propotion) return;

    if (valueDebttoTotalAsset > 50) {
      return "bad";
    }
    return "good";
  };

  // ชำระหนี้ต่อรายรับ
  const valueDebttoSalary = useMemo(() => {
    let sum = 0;
    const debtPermonth =
      balanceData?.sum_debt_short_permonth +
      balanceData?.sum_debt_long_permonth;
    const salaryPermonth = balanceData?.salary_propotion
      ? balanceData?.salary_propotion / 12
      : 0;
    sum = salaryPermonth > 0 ? (debtPermonth / salaryPermonth) * 100 : 0;
    return sum;
  }, [balanceData]);
  const getDebttoSalaryStatus = () => {
    if (valueDebttoSalary > 50) {
      return "bad";
    }
    return "good";
  };

  // การออม
  const valueConservation = useMemo(() => {
    let sum = 0;
    if (balanceData?.sum_expenses_invest_saving) {
      sum = balanceData?.sum_expenses_invest_saving;
    }
    const finalResult =
      sum > 0 ? (sum / balanceData?.salary_propotion) * 100 : 0;
    return finalResult;
  }, [balanceData]);
  const getConservationStatus = () => {
    if (!balanceData?.sum_expenses_invest_saving) return;

    if (valueConservation < 10) {
      return "bad";
    }
    return "good";
  };

  // การลงทุน
  const valueInvest = useMemo(() => {
    let sum = 0;
    if (balanceData?.sum_property_invest) {
      sum =
        balanceData?.net_wealth > 0
          ? (balanceData?.sum_property_invest / balanceData?.net_wealth) * 100
          : 0;
    }
    return sum;
  }, [balanceData]);
  const getInvestStatus = () => {
    if (!balanceData?.sum_property_invest) return;

    if (valueInvest > 50) {
      return "good";
    }
    return "bad";
  };

  // วางแผนเกษียณ
  const getInvestSum = InvestmentReturnCal(
    retireData,
    balanceData,
    strategy,
    educationData
  )?.map((bf_investment_assets, index) => {
    return {
      result: bf_investment_assets?.asset_invest,
      age: retireData?.bf_plan_age[index],
    };
  });

  const retirementAgeAF = straigyLists?.includes("strategy_age_retire")
    ? retireData?.strategy_age_retire
    : retireData?.age_retire;

  const lastResultBF = getInvestSum[getInvestSum?.length - 1];
  const retirementAge = retireData?.age_retire;
  const retireBF = getInvestSum.find(
    (result) => result.age === retirementAge
  )?.result;
  const retireAF = getInvestSumAF.find(
    (result) => result.age === retirementAgeAF
  )?.result;
  const getremainBF = getInvestSum?.filter((thisRemain, i) => {
    if (thisRemain?.result <= 0) return { ...thisRemain };
  })?.[0];
  const remainBF = getremainBF?.age;
  const beforeDiffYear = retireData?.age_retire - retireData?.age_current;

  const sumBeforeRetireInvest = useMemo(() => {
    const convertedMonth = convertYearToMonth(beforeDiffYear);
    const calPercent =
      retireData?.investment_bf_retirement < 0
        ? 3
        : retireData?.investment_bf_retirement;

    const sumPMT = calPMTFVA(
      Math.abs(lastResultBF?.result),
      calPercent / 100 / 12,
      convertedMonth
    );
    return sumPMT;
  }, [retireData]);

  const strategyChange = retireData?.strategy_sum ? true : false;

  const dataPlanAF = [
    ...InvestmentReturnCalAfter(
      retireData,
      strategy,
      balanceData,
      educationData
    )?.map((af_investment_assets) => {
      return af_investment_assets?.asset_invest;
    }),
  ];

  // retireData?.af_investment_assets?.map(
  //   (af_investment_assets) => {
  //     return af_investment_assets?.results;
  //   }
  // );

  const lastResultAF = getInvestSumAF[getInvestSumAF?.length - 1];
  const getremainAF = getInvestSumAF?.filter((thisRemain, i) => {
    if (thisRemain?.result <= 0) return { ...thisRemain };
  })?.[0];
  const remainAF = Number(getremainAF?.age) ;
  const afterDiffYear =
    retireData?.strategy_age_retire - retireData?.age_current;

  const sumAfterRetireInvest = useMemo(() => {
    const convertedMonth = convertYearToMonth(afterDiffYear);
    const calPercent =
      retireData?.strategy_investment_bf_retirement_change < 0
        ? 3
        : retireData?.strategy_investment_bf_retirement_change;
    const sumPMT = calPMTFVA(
      lastResultAF?.result < 0
        ? Math.abs(lastResultAF?.result)
        : lastResultAF?.result,
      calPercent / 100 / 12,
      convertedMonth
    );
    return sumPMT;
  }, [retireData]);

  const getDetailBF = () => {
    if (strategyChange) {
      if (lastResultBF?.result > 0) {
        return [
          {
            icon: <ICON_CHECK className=" w-[14px] h-[14px] text-maincyan" />,
            render: () => {
              return (
                <div className=" flex gap-1">
                  <div className=" w-full text-[10px] flex-none">
                    <div className=" flex flex-wrap w-full h-fit ">
                      เริ่มวางแผนเกษียณตอนอายุ {retireData?.age_current} ปี
                      ประมาณการณ์เมื่อเกษียณอายุตอน {retireData?.age_retire} ปี
                      จะมีสินทรัพย์ลงทุนรวม
                    </div>
                    <div className="font-medium ">
                      {" "}
                      <span className="text-mainblue">
                        {numeral(retireBF)?.format("0,0.00")}
                      </span>{" "}
                      บาท
                    </div>
                  </div>
                </div>
              );
            },
          },
          {
            icon: (
              <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />
            ),
            render: () => {
              return (
                <div className=" flex gap-1">
                  <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {retireData?.strategy_age_dead
                        ? retireData?.strategy_age_dead
                        : retireData?.age_dead || "-"}
                    </div>
                    <span className="text-mainblue font-normal">ปี</span>
                    <div>แต่อย่าประมาทนะ</div>
                  </div>
                </div>
              );
            },
          },
        ];
      }
      return [
        {
          icon: (
            <ICON_CHECK className=" w-[14px] h-[14px] text-maincyan flex-none" />
          ),
          render: () => {
            return (
              <div className=" flex gap-1">
                <div className="text-[10px] ">
                  {/* คาดการณ์สินทรัพย์เพื่อการลงทุน ณ อายุ{" "} */}
                  เริ่มวางแผนเกษียณตอนอายุ{""}
                </div>
                <div className={cn("text-[10px] flex space-x-1")}>
                  <div className="font-semibold">
                    {_.isNaN(retireData?.age_current)
                      ? "-"
                      : retireData?.age_current}{" "}
                    ปี
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />,
          render: () => {
            return (
              <div className=" flex flex-col">
                <div className="flex gap-1">
                  <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(remainBF) ? "-" : remainBF} ปี
                    </div>
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_CLOSE className=" w-[14px] h-[14px] text-maincyan" />,
          render: () => {
            return (
              <div className="flex flex-col">
                <div className=" flex gap-1">
                  <div className="text-[10px] ">
                    ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ{" "}
                  </div>
                  <div className={cn("text-[10px] font-semibold")}>
                    {_.isNaN(retireData?.age_dead) ? "-" : retireData?.age_dead}{" "}
                    ปี
                  </div>
                </div>
                <div>
                  <div className="text-[10px] ">
                    ยังขาดอยู่ทั้งหมด{" "}
                    <span className=" font-medium text-black">
                      {lastResultBF?.result < 0
                        ? numeral(lastResultBF?.result * -1)?.format("0,0")
                        : numeral(lastResultBF?.result)?.format("0,0")}
                      {""} บาท
                    </span>
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_STAR className=" w-[14px] h-[14px] text-maingreen" />,
          render: () => {
            if (retireData?.age_retire - retireData?.age_current !== 0) {
              return (
                <div className="flex flex-col">
                  <div className=" flex gap-1">
                    <div className="text-[10px] ">ควรวางแผนลงทุนผลตอบแทน</div>
                    <div className={cn("text-[10px] font-semibold")}>
                      {retireData?.investment_bf_retirement < 0
                        ? "3"
                        : retireData?.investment_bf_retirement}
                      %
                    </div>
                  </div>
                  <div className="text-[10px] flex space-x-1">
                    <div>เป็นระยะเวลา</div>
                    <span className=" font-semibold">
                      {_.isNaN(beforeDiffYear) ? "-" : beforeDiffYear} ปี
                    </span>{" "}
                    <div>เดือนละ</div>
                    <span className=" font-semibold text-mainblue">
                      {numeral(sumBeforeRetireInvest)?.format("0,0")} บาท
                    </span>
                  </div>
                </div>
              );
            }

            return (
              <div className="flex flex-col">
                <div className="  text-[10px] ">
                  {`อย่าประมาทในการวางแผนเกษียณ ตอนคุณอายุ `}
                  <span className="font-semibold">
                    {_.isNaN(retireData?.age_current)
                      ? "-"
                      : retireData?.age_current}{" "}
                    ปี
                  </span>
                  {` รายรับของคุณจะไม่พอใช้ ควรขยายเวลาเกษียณ หรือรีบหารายได้เพิ่มเติม`}
                </div>
              </div>
            );
          },
        },
      ];
    } else {
      if (lastResultBF?.result > 0) {
        return [
          {
            icon: <ICON_CHECK className=" w-[14px] h-[14px] text-maincyan" />,
            render: () => {
              return (
                <div className="text-[10px] flex flex-col gap-1">
                  <div className=" ">
                    คาดการณ์สินทรัพย์เพื่อการลงทุน ณ วันเกษียณอายุ
                  </div>
                  <div className="flex">
                    <span className="font-medium mr-1">
                      {_.isNaN(retireData?.age_retire)
                        ? "-"
                        : retireData?.age_retire}{" "}
                      ปี
                    </span>
                    <div className="flex space-x-1">
                      <div>จำนวน</div>
                      <span className=" font-medium text-mainblue">
                        {numeral(retireBF)?.format("0,0.00")}
                      </span>
                    </div>
                  </div>
                </div>
              );
            },
          },
          {
            icon: (
              <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />
            ),
            render: () => {
              return (
                <div className=" flex gap-1">
                  <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(retireData?.age_dead)
                        ? "-"
                        : retireData?.age_dead}
                    </div>
                    <span className="text-mainblue font-normal">ปี</span>
                    <div>แต่อย่าประมาทนะ</div>
                  </div>
                </div>
              );
            },
          },
        ];
      }
      return [
        {
          icon: <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />,
          render: () => {
            return (
              <div className=" flex gap-1">
                <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                <div className={cn("text-[10px] flex space-x-1")}>
                  <div className="font-semibold">
                    {" "}
                    {_.isNaN(remainBF) ? "-" : remainBF} ปี
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_CLOSE className=" w-[14px] h-[14px] text-mainred" />,
          render: () => {
            return (
              <div className="flex flex-col">
                <div className=" flex gap-1 flex-wrap ">
                  <div className="text-[10px] ">
                    ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ
                  </div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(retireData?.age_dead)
                        ? "-"
                        : retireData?.age_dead}{" "}
                      ปี
                    </div>
                  </div>
                </div>
                <div className="flex gap-1 text-[10px]">
                  <div className="  text-[10px]">ยังขาดอยู่ทั้งหมด</div>
                  <div className={cn("text-[10px] font-semibold text-black")}>
                    {_.isNaN(lastResultBF?.result)
                      ? "-"
                      : numeral(
                          lastResultBF?.result < 0
                            ? lastResultBF?.result * -1
                            : lastResultBF?.result
                        ).format("0,0")}{" "}
                    บาท
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_STAR className=" w-[14px] h-[14px] text-maincyan" />,
          render: () => {
            return (
              <div className="flex flex-col">
                <div className=" flex gap-1">
                  <div className="text-[10px] ">ควรวางแผนลงทุนผลตอบแทน</div>
                </div>
                <div className={cn("text-[10px] font-semibold")}>
                  {retireData?.investment_bf_retirement < 0
                    ? "3"
                    : retireData?.investment_bf_retirement}{" "}
                  %<span className=" font-normal"> เป็นระยะเวลา </span>
                  <span className="font-semibold">
                    {_.isNaN(beforeDiffYear) ? "-" : beforeDiffYear} ปี{" "}
                  </span>
                  <span className="font-normal">เดือนละ </span>
                  <span className="text-mainblue">
                    {_.isNaN(sumBeforeRetireInvest)
                      ? "-"
                      : numeral(sumBeforeRetireInvest)?.format("0,0")}
                  </span>
                </div>
              </div>
            );
          },
        },
      ];
    }
  };

  const getDetailAF = () => {
    if (strategyChange) {
      if (lastResultAF?.result > 0) {
        return [
          {
            icon: <ICON_CHECK className=" w-[14px] h-[14px] text-maincyan" />,
            render: () => {
              return (
                <div className="text-[10px] flex flex-col gap-1">
                  <div className=" ">
                    เริ่มวางแผนเกษียณตอนอายุ {retireData?.age_current} ปี
                    ประมาณการณ์เมื่อเกษียณอายุตอน{" "}
                    {straigyLists?.includes("strategy_age_retire")
                      ? retireData?.strategy_age_retire
                      : retireData?.age_retire}{" "}
                    ปี จะมีสินทรัพย์ลงทุนรวม
                  </div>
                  <div className="font-medium ">
                    {" "}
                    <span className="text-mainblue">
                      {numeral(retireAF)?.format("0,0.00")}
                    </span>{" "}
                    บาท
                  </div>
                </div>
              );
            },
          },
          {
            icon: (
              <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />
            ),
            render: () => {
              return (
                <div className=" flex gap-1">
                  <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {retireData?.strategy_age_dead
                        ? retireData?.strategy_age_dead
                        : retireData?.age_dead || "-"}
                    </div>
                    <span className="text-mainblue font-normal">ปี</span>
                    <div>แต่อย่าประมาทนะ</div>
                  </div>
                </div>
              );
            },
          },
        ];
      }
      return [
        {
          icon: (
            <ICON_CHECK className=" w-[14px] h-[14px] text-maincyan flex-none" />
          ),
          render: () => {
            return (
              <div className=" flex gap-1">
                <div className="text-[10px] ">
                  {/* คาดการณ์สินทรัพย์เพื่อการลงทุน ณ อายุ{" "} */}
                  เริ่มวางแผนเกษียณตอนอายุ{" "}
                </div>
                <div className={cn("text-[10px] flex space-x-1")}>
                  <div className="font-semibold">
                    {_.isNaN(retireData?.age_current)
                      ? "-"
                      : retireData?.age_current}{" "}
                    ปี
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />,
          render: () => {
            return (
              <div className=" flex flex-col">
                <div className="flex gap-1">
                  <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(remainAF) ? "-" : remainAF} ปี
                    </div>
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_CLOSE className=" w-[14px] h-[14px] text-maincyan" />,
          render: () => {
            if (afterDiffYearCheck !== 0) {
              return (
                <div className="flex flex-col">
                  <div className=" flex gap-1">
                    <div className="text-[10px] ">
                      ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ{" "}
                    </div>
                    <div className={cn("text-[10px] font-semibold")}>
                      {_.isNaN(retireData?.age_dead)
                        ? "-"
                        : retireData?.age_dead}{" "}
                      ปี
                    </div>
                  </div>
                  <div>
                    <div className="text-[10px] ">
                      ยังขาดอยู่ทั้งหมด{" "}
                      <span className=" font-medium text-black">
                        {lastResultAF?.result < 0
                          ? numeral(lastResultAF?.result * -1)?.format("0,0")
                          : numeral(lastResultAF?.result)?.format("0,0")}
                        {""} บาท
                      </span>
                    </div>
                  </div>
                </div>
              );
            }

            return (
              <div className="flex flex-col">
                <div className="  text-[10px] ">
                  {`อย่าประมาทในการวางแผนเกษียณ ตอนคุณอายุ `}
                  <span className="font-semibold">
                    {_.isNaN(remainAF) ? "-" : remainAF} ปี
                  </span>
                  {` รายรับของคุณจะไม่พอใช้ ควรขยายเวลาเกษียณ หรือรีบหารายได้เพิ่มเติม`}
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_STAR className=" w-[14px] h-[14px] text-maingreen" />,
          render: () => {
            if (afterDiffYearCheck !== 0) {
              return (
                <div className="flex flex-col">
                  <div className=" flex gap-1">
                    <div className="text-[10px] ">ควรวางแผนลงทุนผลตอบแทน</div>
                    <div className={cn("text-[10px] font-semibold")}>
                      {/* {_.isNaN(retireData?.investment_af_retirement)
                      ? ""
                      : retireData?.investment_af_retirement}{" "} */}
                      {strategyLists?.includes(
                        "strategy_investment_bf_retirement_change"
                      )
                        ? Math.abs(
                            retireData?.strategy_investment_bf_retirement_change
                          )
                        : Math.abs(retireData?.investment_bf_retirement)}
                      %
                    </div>
                  </div>
                  <div className="text-[10px] flex space-x-1">
                    <div>เป็นระยะเวลา</div>
                    <span className=" font-semibold">
                      {_.isNaN(afterDiffYear) ? "-" : afterDiffYear} ปี
                    </span>{" "}
                    <div>เดือนละ</div>
                    <span className=" font-semibold text-mainblue">
                      {numeral(sumAfterRetireInvest)?.format("0,0")} บาท
                    </span>
                  </div>
                </div>
              );
            }

            return (
              <div className="flex flex-col">
                <div className="  text-[10px] ">
                  {`อย่าประมาทในการวางแผนเกษียณ ตอนคุณอายุ `}
                  <span className="font-semibold">
                    {_.isNaN(remainAF) ? "-" : remainAF} ปี
                  </span>
                  {` รายรับของคุณจะไม่พอใช้ ควรขยายเวลาเกษียณ หรือรีบหารายได้เพิ่มเติม`}
                </div>
              </div>
            );
          },
        },
      ];
    } else {
      if (lastResultAF?.result > 0) {
        return [
          {
            icon: <ICON_CHECK className=" w-[14px] h-[14px] text-maincyan" />,
            render: () => {
              return (
                <div className="text-[10px] flex flex-col gap-1">
                  <div className=" ">
                    คาดการณ์สินทรัพย์เพื่อการลงทุน ณ วันเกษียณอายุ
                  </div>
                  <div className="flex">
                    <span className="font-medium mr-1">
                      {_.isNaN(retireData?.age_retire)
                        ? "-"
                        : retireData?.age_retire}{" "}
                      ปี
                    </span>
                    <div className="flex space-x-1">
                      <div>จำนวน</div>
                      <span className=" font-medium text-mainblue">
                        {numeral(retireBF)?.format("0,0.00")}
                      </span>
                    </div>
                  </div>
                </div>
              );
            },
          },
          {
            icon: (
              <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />
            ),
            render: () => {
              return (
                <div className=" flex gap-1">
                  <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(retireData?.age_dead)
                        ? "-"
                        : retireData?.age_dead}
                    </div>
                    <span className="text-mainblue font-normal">ปี</span>
                    <div>แต่อย่าประมาทนะ</div>
                  </div>
                </div>
              );
            },
          },
        ];
      }
      return [
        {
          icon: <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />,
          render: () => {
            return (
              <div className=" flex gap-1">
                <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                <div className={cn("text-[10px] flex space-x-1")}>
                  <div className="font-semibold">
                    {" "}
                    {_.isNaN(remainAF) ? "-" : remainAF} ปี
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_CLOSE className=" w-[14px] h-[14px] text-mainred" />,
          render: () => {
            return (
              <div className="flex flex-col">
                <div className=" flex gap-1 flex-wrap ">
                  <div className="text-[10px] ">
                    ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ
                  </div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(retireData?.age_dead)
                        ? "-"
                        : retireData?.age_dead}{" "}
                      ปี
                    </div>
                  </div>
                </div>
                <div className="flex gap-1 text-[10px]">
                  <div className="  text-[10px]">ยังขาดอยู่ทั้งหมด</div>
                  <div className={cn("text-[10px] font-semibold text-black")}>
                    {_.isNaN(lastResultAF?.result)
                      ? "-"
                      : numeral(
                          lastResultAF?.result < 0
                            ? lastResultAF?.result * -1
                            : lastResultAF?.result
                        ).format("0,0")}{" "}
                    บาท
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_STAR className=" w-[14px] h-[14px] text-maincyan" />,
          render: () => {
            return (
              <div className="flex flex-col">
                <div className=" flex gap-1">
                  <div className="text-[10px] ">ควรวางแผนลงทุนผลตอบแทน</div>
                </div>
                <div className={cn("text-[10px] font-semibold")}>
                  {retireData?.investment_bf_retirement < 0
                    ? "3"
                    : retireData?.investment_bf_retirement}{" "}
                  %<span className=" font-normal"> เป็นระยะเวลา </span>
                  <span className="font-semibold">
                    {_.isNaN(afterDiffYear) ? "-" : afterDiffYear} ปี{" "}
                  </span>
                  <span className="font-normal">เดือนละ </span>
                  <span className="text-mainblue">
                    {_.isNaN(sumAfterRetireInvest)
                      ? "-"
                      : numeral(sumAfterRetireInvest)?.format("0,0")}
                  </span>
                </div>
              </div>
            );
          },
        },
      ];
    }
  };

  let checkAF = lastResultAF?.result;
  let checkBF = lastResultBF?.result;

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText title="วางแผนเกษียณ" icon="/images/grandparents.svg" />
      {/* ก่อนวางแผน */}
      <PdfCard title={"ก่อนวางแผน"}>
        <PdfCardWhite className={"flex flex-col px-3"}>
          <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
            ความเคลื่อนไหวทางการเงิน
          </div>
          <div className="flex space-x-2">
            <div className={cn("w-[230px]")}>
              <LineChartMain
                axisSize={6}
                labels={dataAge()}
                dataPlan={dataPlanBf}
                fontSize="text-[10px]"
                head={``}
                height={150}
                width={230}
                classNameBath={"md:top-[10%]"}
                classNameAge={"right-[-4%] md:right-[0%]"}
              />
            </div>

            <div className="flex flex-col">
              {checkBF > 0 ? (
                <div
                  className={cn(
                    "w-full text-center text-black items-center text-md flex flex-col gap-[9px]",
                    STYLE_PDF_TEXT_NORMAL_11
                  )}
                >
                  <img src="/images/goodface.svg" className="w-6 h-6 mx-auto" />
                  <div>
                    <div>ยินดีด้วย...</div>
                    ท่านสามารถใช้ชีวิตหลังเกษียณได้ตามที่ท่านตั้งใจไว้
                  </div>
                </div>
              ) : (
                <div
                  className={cn(
                    "w-full text-center text-black text-md flex items-center flex-col gap-[9px]",
                    STYLE_PDF_TEXT_NORMAL_11
                  )}
                >
                  <img src="/images/badface.svg" className="w-6 h-6 mx-auto" />
                  <div>
                    ไม่นะ..เมื่อท่านอายุ {retireData?.age_dead} ปี
                    <div>เงินของท่านจะหมดลง ก่อนสิ้นอายุขัย</div>
                  </div>
                </div>
              )}
              <div className="mt-2 space-y-1">
                {getDetailBF()?.map((item, index) => {
                  return (
                    <div key={index} className="flex gap-2.5">
                      <div>{item?.icon}</div>
                      {item?.render && item?.render()}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </PdfCardWhite>
      </PdfCard>

      {/* หลังวางแผน */}
      <PdfCard title={"หลังวางแผน"}>
        <PdfCardWhite className={"flex flex-col px-3"}>
          <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
            ความเคลื่อนไหวทางการเงิน
          </div>
          <div className="flex space-x-2">
            <div className={cn("w-[230px]")}>
              <LineChartMain
                axisSize={6}
                labels={dataAgeAF()}
                dataPlan={dataPlanAF}
                fontSize="text-[10px]"
                head={``}
                height={150}
                width={230}
                classNameBath={"md:top-[10%]"}
                classNameAge={"right-[-4%] md:right-[0%]"}
              />
            </div>

            <div className="flex flex-col">
              {checkAF > 0 ? (
                <div
                  className={cn(
                    "w-full text-center text-black items-center text-md flex flex-col gap-[9px]",
                    STYLE_PDF_TEXT_NORMAL_11
                  )}
                >
                  <img src="/images/goodface.svg" className="w-6 h-6 mx-auto" />
                  <div>
                    <div>ยินดีด้วย...</div>
                    ท่านสามารถใช้ชีวิตหลังเกษียณได้ตามที่ท่านตั้งใจไว้
                  </div>
                </div>
              ) : (
                <div
                  className={cn(
                    "w-full text-center text-black text-md flex items-center flex-col gap-[9px]",
                    STYLE_PDF_TEXT_NORMAL_11
                  )}
                >
                  <img src="/images/badface.svg" className="w-6 h-6 mx-auto" />
                  <div>
                    ไม่นะ..เมื่อท่านอายุ {retireData?.age_dead} ปี
                    <div>เงินของท่านจะหมดลง ก่อนสิ้นอายุขัย</div>
                  </div>
                </div>
              )}
              <div className="mt-2 space-y-1">
                {getDetailAF()?.map((item, index) => {
                  return (
                    <div key={index} className="flex gap-2.5">
                      <div>{item?.icon}</div>
                      {item?.render && item?.render()}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageRetireTwo;
